// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RouteDetailPage_loading__ZAeTf {
  color: #64748b;
  font-size: 14px;
}

/* ROUTE SUMMARY */
.RouteDetailPage_routeCard__8Q1ff {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 12px;
  background: #fff;
  margin-bottom: 12px;
}

.RouteDetailPage_routeGrid__Md6Qz {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  font-size: 13px;
}

.RouteDetailPage_routeGrid__Md6Qz span {
  display: block;
  color: #64748b;
  font-size: 12px;
}

.RouteDetailPage_routeControls__gGj90 {
  margin-top: 10px;
}

/* SEARCH */
.RouteDetailPage_searchBox__JW9v9 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  margin-bottom: 12px;
}

.RouteDetailPage_searchBox__JW9v9 input {
  border: none;
  outline: none;
  width: 100%;
}

/* GRID */
.RouteDetailPage_cardsGrid__BRp6v {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));
  gap: 12px;
}

/* CARD */
.RouteDetailPage_card__N1CHa {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.RouteDetailPage_cardHeader__evc0z {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.RouteDetailPage_cardHeader__evc0z h3 {
  margin: 0;
  font-size: 0.95rem;
}

.RouteDetailPage_cardHeader__evc0z p {
  margin: 0;
  font-size: 0.75rem;
  color: #64748b;
}

/* META */
.RouteDetailPage_meta__3vvzm {
  margin-top: 8px;
  font-size: 0.8rem;
  display: grid;
  gap: 4px;
}

.RouteDetailPage_meta__3vvzm span {
  color: #64748b;
  margin-right: 4px;
}

/* PRODUCTS */
.RouteDetailPage_products__nDElv {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.RouteDetailPage_product__3wzGP {
  border-top: 1px dashed #e2e8f0;
  padding-top: 6px;
}

.RouteDetailPage_productHeader__KSUbX {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
}

/* MARKS */
.RouteDetailPage_marks__mD2yT {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  margin-top: 4px;
}

.RouteDetailPage_mark__jj8oO {
  background: #f1f5f9;
  border-radius: 999px;
  padding: 2px 6px;
  font-size: 0.7rem;
}

.RouteDetailPage_mark__jj8oO button {
  margin-left: 4px;
  border: none;
  background: none;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Admin/Debug/RouteDetailPage.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA,SAAS;AACT;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".loading {\r\n  color: #64748b;\r\n  font-size: 14px;\r\n}\r\n\r\n/* ROUTE SUMMARY */\r\n.routeCard {\r\n  border-radius: 12px;\r\n  border: 1px solid #e2e8f0;\r\n  padding: 12px;\r\n  background: #fff;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.routeGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  gap: 10px;\r\n  font-size: 13px;\r\n}\r\n\r\n.routeGrid span {\r\n  display: block;\r\n  color: #64748b;\r\n  font-size: 12px;\r\n}\r\n\r\n.routeControls {\r\n  margin-top: 10px;\r\n}\r\n\r\n/* SEARCH */\r\n.searchBox {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 10px;\r\n  border-radius: 10px;\r\n  border: 1px solid #e2e8f0;\r\n  background: #fff;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.searchBox input {\r\n  border: none;\r\n  outline: none;\r\n  width: 100%;\r\n}\r\n\r\n/* GRID */\r\n.cardsGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n/* CARD */\r\n.card {\r\n  border-radius: 12px;\r\n  border: 1px solid #e2e8f0;\r\n  padding: 12px;\r\n  background: #fff;\r\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.cardHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n}\r\n\r\n.cardHeader h3 {\r\n  margin: 0;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.cardHeader p {\r\n  margin: 0;\r\n  font-size: 0.75rem;\r\n  color: #64748b;\r\n}\r\n\r\n/* META */\r\n.meta {\r\n  margin-top: 8px;\r\n  font-size: 0.8rem;\r\n  display: grid;\r\n  gap: 4px;\r\n}\r\n\r\n.meta span {\r\n  color: #64748b;\r\n  margin-right: 4px;\r\n}\r\n\r\n/* PRODUCTS */\r\n.products {\r\n  margin-top: 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.product {\r\n  border-top: 1px dashed #e2e8f0;\r\n  padding-top: 6px;\r\n}\r\n\r\n.productHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n/* MARKS */\r\n.marks {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  align-items: center;\r\n  margin-top: 4px;\r\n}\r\n\r\n.mark {\r\n  background: #f1f5f9;\r\n  border-radius: 999px;\r\n  padding: 2px 6px;\r\n  font-size: 0.7rem;\r\n}\r\n\r\n.mark button {\r\n  margin-left: 4px;\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": `RouteDetailPage_loading__ZAeTf`,
	"routeCard": `RouteDetailPage_routeCard__8Q1ff`,
	"routeGrid": `RouteDetailPage_routeGrid__Md6Qz`,
	"routeControls": `RouteDetailPage_routeControls__gGj90`,
	"searchBox": `RouteDetailPage_searchBox__JW9v9`,
	"cardsGrid": `RouteDetailPage_cardsGrid__BRp6v`,
	"card": `RouteDetailPage_card__N1CHa`,
	"cardHeader": `RouteDetailPage_cardHeader__evc0z`,
	"meta": `RouteDetailPage_meta__3vvzm`,
	"products": `RouteDetailPage_products__nDElv`,
	"product": `RouteDetailPage_product__3wzGP`,
	"productHeader": `RouteDetailPage_productHeader__KSUbX`,
	"marks": `RouteDetailPage_marks__mD2yT`,
	"mark": `RouteDetailPage_mark__jj8oO`
};
export default ___CSS_LOADER_EXPORT___;
